import React, { useCallback, useContext, useState } from "react";
import { withRouter, Redirect, Link } from "react-router-dom";
import app from "./firebase";
import { AuthContext } from "./Auth";
import PasswordResetPopUp from "./passwordReset";
import { Form, Container, Button, Alert, Row, Col, Card,Tooltip } from "react-bootstrap";
import './login.css';
import logo from '../media/Picture1.png';

const Login = ({ warning, disableRegister,loginMessage, history }) => {
    const [reset, setReset] = useState(false);
    const { currentUser } = useContext(AuthContext);
    const [alert, setAlert] = useState(null);
    const handleLogin = useCallback(
        async (event) => {
            event.preventDefault();
            const { email, password } = event.target.elements;
            try {
                await app.auth().setPersistence("session");
                await app.auth().signInWithEmailAndPassword(email.value, password.value);
                history.push("/");
            } catch (error) {
                // alert(error.message);
                setAlert(error.message);
            }
        },
        [history]
    );

    const showPopUp = () => setReset(true);
    const onHide = () => setReset(false);

    if (currentUser) {
        return <Redirect to="/" />;
    }

    return (
        <Container fluid className="login-page">
            <Row className="justify-content-center align-items-center min-vh-100">
                <Col md={10} lg={8} xl={7}>
                    <Card className="scientific-login-card">
                        <Row className="g-0">
                            <Col md={5} className="login-sidebar d-flex flex-column justify-content-between">
                                <div className="p-4">
                                    <img src={logo} alt="Logo" className="scientific-logo mb-4" />
                                    <h3 className="sidebar-title">Parkinson Registry</h3>
                                    <div className="sidebar-divider"></div>
                                    <h5 className="sidebar-subtitle">Bioinformatics and Human Electrophysiology Laboratory</h5>
                                    <p className="sidebar-institution">Department of Informatics - Ionian University</p>
                                </div>
                                <div className="sidebar-footer p-4">
                                    <p className="text-center mb-0">&copy; {new Date().getFullYear()} BIHELab</p>
                                </div>
                            </Col>
                            <Col md={7}>
                                <Card.Body className="px-4 py-5">
                                    <h2 className="login-heading mb-4">Sign In</h2>

                                    {warning && (
                                        <Alert variant="warning" className="mb-4 scientific-alert">
                                            <Alert.Heading className="fs-6">Development Notice</Alert.Heading>
                                            <p className="small mb-0">
                                                This application is under development and provided for experimental purposes only.
                                                Not intended for recording real patient data.
                                            </p>
                                        </Alert>
                                    )}
                                    {loginMessage !=='0' && (
                                        <Alert variant="warning" className="mb-4 scientific-alert">
                                            <Alert.Heading className="fs-6">Important Message</Alert.Heading>
                                            <p className="small mb-0">
                                                {loginMessage}
                                            </p>
                                        </Alert>
                                    )}

                                    <Form onSubmit={handleLogin}>
                                        <Form.Group className="mb-3" controlId="formEmail">
                                            <Form.Label className="form-label">Email Address</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                placeholder="Enter your email"
                                                className="scientific-input"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-4" controlId="formPassword">
                                            <Form.Label className="form-label">Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="password"
                                                placeholder="Enter your password"
                                                className="scientific-input"
                                                required
                                            />
                                        </Form.Group>
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            className="scientific-button w-100 mb-3">
                                            Sign In
                                        </Button>
                                        {alert!=null && (
                                            <Alert variant="danger" className="mb-4 scientific-alert">
                                                <Alert.Heading className="fs-2">Login Error</Alert.Heading>
                                                <p className="small mb-0">
                                                    {alert}
                                                </p>
                                            </Alert>
                                        )}
                                        <div className="d-flex justify-content-between align-items-center mt-3 mb-4">
                                            <Button
                                                variant="link"
                                                className="p-0 scientific-link"
                                                onClick={showPopUp}>
                                                Forgot Password?
                                            </Button>

                                            {!disableRegister && (
                                                <Link to="/signup" className="scientific-link register-link">
                                                    Create Account
                                                </Link>
                                            )}
                                        </div>
                                    </Form>

                                    <div className="scientific-footer text-center mt-4">
                                        <p className="small text-muted mb-0">Secure Authentication System</p>
                                    </div>
                                </Card.Body>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
            <PasswordResetPopUp show={reset} onHide={onHide} />
        </Container>
    );
};

Login.defaultProps = {
    disableRegister: false,
    warning: false,
};

export default withRouter(Login);